import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Inject,
	Input,
	LOCALE_ID,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild
} from "@angular/core";

import {
	LogCat,
	LogManager
} from "../../../log";

import { DateTimePickerComponent, FormatSettings } from "@progress/kendo-angular-dateinputs";
import { IDateRange } from "../date.range.picker/date.range.picker.interface";


/*
* Selector: cp-date-range-picker
* Change Detection: OnPush
* View Encapsulation: Emulated
*
* Inputs:
* dateRange: IDateRange			//
* disabled: boolean				// Optional
*
* Outputs:
* open?: EventEmitter<any>		// Optional
* close?: EventEmitter<any>		// Optional
* onChange?: EventEmitter<any>	// Optional, for emitting event: {event: DOMEvent, dateRange: { from: Date, to: Date }}
* */
@Component({
	selector:'cp-datetime-range-picker',
	templateUrl: './datetime.range.picker.html',
	styleUrls: ['./datetime.range.picker.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class DateTimeRangePickerComponent implements OnInit, OnChanges {
	@Input() dateTimeRange: IDateRange;
	@Input() rangeIsMandatory: boolean;

	@Output() onChange: EventEmitter<IDateRange> = new EventEmitter<IDateRange>(false);
	@ViewChild('todatetimepicker', {static: false}) public toDateTimePicker: DateTimePickerComponent;

	public format: FormatSettings;
	public fromDateTime: Date;
	public toDateTime: Date;
	public validDateTimeRange: boolean = false;

	constructor(private cd: ChangeDetectorRef,
				@Inject( LOCALE_ID ) private locale: string) {
		this.format = this.getDateTimeFormat();
	}

	public ngOnChanges(changes: SimpleChanges){
		if (changes["dateTimeRange"]) {
			this.fromDateTime = this.dateTimeRange?.from;
			this.toDateTime = this.dateTimeRange?.to;
			this.dateTimeRangeValidation();
		}
	}

	public ngOnInit(){
		this.fromDateTime= this.dateTimeRange?.from;
		this.toDateTime = this.dateTimeRange?.to;
	}

	public handleSelectionFromChange($event: Date) {
		this.fromDateTime  = $event;
		this.dateTimeRange.from = $event;
		this.handleSelectionRangeChange();
	}

	public handleSelectionToChange($event: Date) {
		this.toDateTime  = $event;
		this.dateTimeRange.to = $event;
		this.handleSelectionRangeChange();
	}

	public onFromDateTimePickerClose(e){
		if (this.fromDateTime &&!this.toDateTime) {
			this.toDateTimePicker.toggle(true);
			this.toDateTimePicker.focus();
		}
	}

	public dateTimeRangeValidation(){
		if (this.rangeIsMandatory) {
			this.validDateTimeRange = this.fromDateTime && this.toDateTime && this.fromDateTime <= this.toDateTime;
		} else {
			if (this.fromDateTime && this.toDateTime) {
				this.validDateTimeRange = this.fromDateTime <= this.toDateTime;
			} else {
				this.validDateTimeRange = true;
			}
		}
		this.cd.detectChanges();
	}

	private handleSelectionRangeChange() {
		LogManager.debug(LogCat.RisWorklistCategories.DateFilter,"DateTimeRangePickerCalendarComponent.handleSelectionRangeChange");
		this.dateTimeRangeValidation();
		this.onChange.emit(this.dateTimeRange);
	}

	private getDateTimeFormat(): FormatSettings {
		let format: FormatSettings;

		if (this.locale == 'he-IL') { //the format is set specifically for he-IL because for some reason short format was presented with . and not with /
			format = { inputFormat: { pattern: 'dd/MM/yyyy HH:mm'},  displayFormat: { pattern: 'dd/MM/yyyy HH:mm'}};
		}
		else {
			format = { inputFormat: { datetime: 'short'},  displayFormat: { datetime: 'short'}};
		}

		return format;
	}
}

